<template>
    <div>
        <div class="d-flex flex-column question">
            <div class="text-muted mr-1 mb-1">Question:</div>
            Instructions:
            <div v-html="question.content.instruction"> </div>

            Question Text:
            <div id="disabled-hot-text-container">
                <TipTap
                    v-model="question.content.question"
                    :menu_items="[]"
                    :readonly="true"
                />
            </div>
            
        </div>
    </div>
</template>

<style lang="scss">

#disabled-hot-text-container {
    pointer-events: none;
}

#disabled-hot-text-container .clickable {
    pointer-events: auto;
}

table {
    width: 100%;
}

table td {
    border: 1px solid #999;
    padding: 1em;
}
</style>

<script>
export default {
    data: () => ({}),
    props: ['question'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
    },
    methods: {
        saveQuestion () {
            this.$emit('saveQuestion')
        }
    }
}
</script>
